export enum SignalRTargets {
    reportUpdate_embedTokenAndURL = "reportUpdate_embedTokenAndURL",
    //reportUpdate_error = "reportUpdate_error",
    reportUpdate_status = "reportUpdate_status",
    reportUpdate_error = "reportUpdate_error"
}